import {Component, Input, OnInit} from '@angular/core';
import {MyModalProvider} from "../../providers/my-modal/my-modal";
import {UtilProvider} from "../../providers/util/util";
import {ToastController} from "ionic-angular/index";

/**
 * Generated class for the ModalTypeQrComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modal-type-qr',
  templateUrl: 'modal-type-qr.html',
  // animations: [fadeInAnimation],
})
export class ModalTypeQrComponent implements OnInit{

  // @HostBinding('@fadeInAnimation') fadeInAnimation = true;

  @Input() data: any;

  constructor(private myModal: MyModalProvider,public util:UtilProvider,public toast:ToastController) {
    console.log('Hello ModalTypeQrComponent Component');


  }


  ngOnInit(): void {

  }

  public confirm(){
    this.myModal.dismiss();
  }

  copySysCode(){
    //noinspection TypeScriptUnresolvedVariable
    // alert(this.util.sys_code);
    if (!navigator['clipboard']) {
      this.fallbackCopyTextToClipboard(this.util.sys_code);
      return;
    }
    //noinspection TypeScriptUnresolvedVariable
    navigator['clipboard'].writeText(this.util.sys_code).then(() => {
      let toast = this.toast.create({
        message:'复制成功',
        duration: 1500
      });
      toast.present();
    }, (err) => {
      let toast = this.toast.create({
        message:'当前系统不支持黏贴板，请手动复制。',
        duration: 1500
      });
      toast.present();
    });
  }

  fallbackCopyTextToClipboard(text){
    var textArea:any = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    // if(this.platform.is('ios')){
    let oldContentEditable = textArea.contentEditable;
    let oldReadOnly = textArea.readOnly;
    let range = document.createRange();

    textArea.contentEditable = true;
    textArea.readOnly = false;
    range.selectNodeContents(textArea);

    let s = window.getSelection();
    s.removeAllRanges();
    s.addRange(range);

    textArea.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

    textArea.contentEditable = oldContentEditable;
    textArea.readOnly = oldReadOnly;
    // }



    try {
      var successful = document.execCommand('copy');
      var msg = successful ? '成功' : '失败';

      let toast = this.toast.create({
        message:'复制' + msg,
        duration:1500
      });
      toast.present();
    } catch (err) {
      let toast = this.toast.create({
        message:'当前系统不支持黏贴板，请手动复制。',
        duration: 1500
      });
      toast.present();
    }

    document.body.removeChild(textArea);
  }
}



// WEBPACK FOOTER //
// ./src/components/modal-type-qr/modal-type-qr.ts